"use client";

import React from "react";
var __jsx = React.createElement;
import FooterCopyrightMessage from "../components/copyright";
import FooterLinks from "../components/links";
import { BancogralContrastFooterLogo } from "../components/logos";
import useCssModules from "@lib/hooks/use-css-modules";
import MaxWidthContainer from "@modules/layout/components/shared/muscle-max-width";
const MobileFooter = _ref => {
  var _cssModules$footers$f;
  let {} = _ref;
  const {
    cssModules
  } = useCssModules();
  const {
    containerClassNames,
    entityLogoContainerClassNames,
    entityLogoClassNames
  } = (_cssModules$footers$f = cssModules === null || cssModules === void 0 ? void 0 : cssModules.footers.footerBancogral) !== null && _cssModules$footers$f !== void 0 ? _cssModules$footers$f : {};
  return __jsx(MaxWidthContainer, null, __jsx("div", {
    className: containerClassNames
  }, __jsx("div", {
    className: entityLogoContainerClassNames
  }, __jsx(BancogralContrastFooterLogo, {
    className: entityLogoClassNames
  })), __jsx(FooterLinks, null), __jsx(FooterCopyrightMessage, null)));
};
export default MobileFooter;